import React from "react";
import { FormattedMessage } from "react-intl";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { Box, Grid, GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";

const tips = [
  {
    title: "live_sessions.tips.descriptive_title",
    body: "live_sessions.tips.descriptive_body",
  },
  {
    title: "live_sessions.tips.organized_title",
    body: "live_sessions.tips.organized_body",
  },
  {
    title: "live_sessions.tips.global_community_title",
    body: "live_sessions.tips.global_community_body",
  },
];

export const LiveSessionScheduleTips = () => {
  const getTipContent = ({ title, body, rowNumber }) => (
    <GridItem gridRow={rowNumber}>
      <Grid width="100%" gridRowGap={2}>
        <GridItem gridRow={1}>
          <Text size="tiny" fontWeight="medium" as="h4" textAlign="left">
            <FormattedMessage id={title} />
          </Text>
        </GridItem>
        <GridItem gridRow={2}>
          <Text size="micro" textAlign="left">
            <FormattedMessage id={body} />
          </Text>
        </GridItem>
      </Grid>
    </GridItem>
  );

  return (
    <Grid
      width="100%"
      gridRowGap={6}
      marginTop={[8, 0, 0]}
      paddingRight={[0, 4, 0]}
      paddingLeft={[0, 4, 6]}
    >
      <GridItem gridRow={1}>
        <Text
          size="micro"
          fontWeight="medium"
          style={{ textTransform: "uppercase" }}
          as="h2"
          textAlign="left"
        >
          <FormattedMessage id="live_sessions.tips.title" />
        </Text>
        <Box width="100%" borderBottom="1px solid" borderColor="langsat" marginTop={2} />
      </GridItem>
      {tips.map(({ title, body }, index) =>
        getTipContent({
          title,
          body,
          rowNumber: index + 2,
        })
      )}
    </Grid>
  );
};

export default LiveSessionScheduleTips;
